'use client';

import {
  NotebookIcon,
  ListBulletsIcon,
  ClipboardTextIcon,
  CaretRightIcon as ChevronRightIcon,
} from '@phosphor-icons/react';

const MobileNotebookMenu = ({ onScreenChange }) => {
  const menuItems = [
    {
      id: 'my-notebooks',
      label: 'My Notebooks',
      icon: NotebookIcon,
      description: 'Collection of all questions you have bookmarked',
    },
    {
      id: 'chapter-wise',
      label: 'Chapter-wise Notebooks',
      icon: ListBulletsIcon,
      badge: false,
      description: 'All your bookmarked Qs categorized Chapter-wise',
    },
    {
      id: 'test-wise',
      label: 'Test-wise Notebooks',
      icon: ClipboardTextIcon,
      badge: false,
      description: 'All your bookmarked Qs categorized Test-wise',
    },
  ];

  return (
    <div className="min-h-screen bg-[var(--q3-surface-default)] flex flex-col">
      {/* Fixed Header */}
      <div className="sticky top-0 z-20 bg-[var(--q3-surface-default)] px-4 pt-6 pb-2">
        <h1 className="text-2xl font-bold text-[var(--q3-neutral-default)] mb-2">Notebooks</h1>
        <div className="border-b border-[var(--q3-stroke-light)]" />
      </div>

      {/* Scrollable Section */}
      <div className="flex-1 overflow-y-auto px-4 space-y-4 pt-4 pb-6">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onScreenChange(item.id)}
            className="w-full flex items-center justify-between p-4 bg-[var(--q3-surface-default)] border border-[var(--q3-stroke-normal)] rounded-lg hover:bg-[var(--q3-surface-glass)] transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="p-2 bg-[var(--q3-surface-glass)] rounded-lg">
                <item.icon size={20} weight="regular" className="text-[var(--q3-neutral-default)]" />
              </div>
              <div className="text-left">
                <span className="font-medium text-[var(--q3-neutral-default)]">{item.label}</span>
              </div>
            </div>

            <div className="flex items-center gap-2">
              {item.badge && (
                <span className="bg-[#FF3366] text-white text-xs px-2 py-1 rounded-full font-semibold">
                  {item.badge}
                </span>
              )}
              <ChevronRightIcon size={20} weight="regular" className="text-[var(--q3-neutral-light)]" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileNotebookMenu;
